// Product.js
export default class Product {
    constructor(
        names = {},
        descriptions = {},
        datasheets = {},
        photo = {},
        year = 0,
        position = 0,
        mainProductInfos = [] 
    ) {
        this.names = names;
        this.descriptions = descriptions;
        this.datasheets = datasheets;
        this.photo = photo;
        this.year = year;
        this.position = position;
        this.mainProductInfos = mainProductInfos;
    }

    // Make sure to include a validation method if needed
    isValid(currentLanguage) {
        let result = true;
        
        // Add necessary validation checks here
        if (!this.names[currentLanguage] || !this.names[currentLanguage].trim()) result = false;
        if (!this.descriptions[currentLanguage] || !this.descriptions[currentLanguage].trim()) result = false;
        
        // Validate photo is required
        if (!this.photo || !this.photo.url || !this.photo.url.trim()) result = false;
        
        // Ensure `mainProductInfos` is valid (only if there are items added)
        if (this.mainProductInfos && this.mainProductInfos.length > 0) {
            for (let info of this.mainProductInfos) {
                // Check both Portuguese and English for each item
                const supportedLanguages = ['pt', 'en'];
                for (let lang of supportedLanguages) {
                    if (
                        !info.keys || !info.keys[lang] || !info.keys[lang].trim() ||
                        !info.values || !info.values[lang] || !info.values[lang].trim()
                    ) {
                        result = false;
                        break;
                    }
                }
                if (!result) break; // Exit outer loop if validation failed
            }
        }

        return result;
    }
}
